import React, {useMemo, useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {PURCHASE_ORDER_CONTENT} from "./jobPurchaseOrderReducer";
import {setJobPurchaseOrderErrorMessage, setJobPurchaseOrderPopupStep} from "./jobPurchaseOrderActions";
import {updateJobOrder} from "./jobOrderApi";
import {setJobEditPopupIframeWaitingReceipt} from "../jobEditPopup/jobEditActions";


const JobPurchaseOrderPopupFooterButtons = (props) => {

  const {setJobPurchaseOrderPopupStep, purchaseOrderStep, closePopup, purchaseOrderInvoiceNumber, updateJobOrder,
    purchaseOrderInvoiceFile, jobCartItems, setJobPurchaseOrderErrorMessage, setJobEditPopupIframeWaitingReceipt,
    jobEditPopupIframeWaitingReceipt} = props;

  const [loading, setLoading] = useState(false);

  const isFirstStep = purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrder
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoice
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderPay;
  const isPurchaseOrderSuccess = purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderSuccess
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoiceSuccess
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderPaySuccess;
  const isPurchaseOrderError = purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderError
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoiceError
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderPayError;

  const isPayStep = purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderPay;

  const prevClick = () => {
    if (isFirstStep) {
      closePopup();
      return
    }
    if (isPurchaseOrderError) {
      setJobPurchaseOrderPopupStep(purchaseOrderStep - 2);
      setJobPurchaseOrderErrorMessage("");
      return
    }
    setJobPurchaseOrderPopupStep(purchaseOrderStep - 1)
  }

  const nextClick = async () => {
    if (isPurchaseOrderSuccess) {
      closePopup();
      return
    }
    if (purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrder) {
      setJobEditPopupIframeWaitingReceipt(true);
      return
      // wait for iframe
    }
    setLoading(true);
    const updated = await updateJobOrder();
    setLoading(false);
    setJobPurchaseOrderPopupStep(updated ? purchaseOrderStep + 1 : purchaseOrderStep + 2);
  }

  const prevDisabled = false; // add validation
  const nextDisabled = useMemo(() => {
    if (purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrder) {
      return !jobCartItems.length
    }
    if (purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoice) {
      return !purchaseOrderInvoiceNumber || !purchaseOrderInvoiceFile
    }
    return false
  }, [jobCartItems, purchaseOrderStep, purchaseOrderInvoiceNumber, purchaseOrderInvoiceFile]); // add validation

  return (
    <div className="ui-popup-footer job-payment__container">
      {isPurchaseOrderSuccess ? null : (
        <button className={"ui-button5 ui-button5--small ui-button5--145 ui-button5--black-border"}
                onClick={prevClick}
                disabled={prevDisabled}>
          <FormattedMessage id={isFirstStep ? "messageBox.buttons.close" : "messageBox.buttons.back"}/>
        </button>
      )}
      {isPurchaseOrderError ? null : (
        <button className={"ui-button5 ui-button5--small  ui-button5--145"
          + (isPayStep ? " ui-button4--red p-0" : " ui-button5--black")
          + (nextDisabled ? " ui-button5--disabled2" : "")}
                onClick={loading || nextDisabled ? null : nextClick}
                disabled={nextDisabled}>
          {loading || jobEditPopupIframeWaitingReceipt ? <div className="ui-loader ui-loader--white ui-loader--auto"/> : <FormattedMessage id={
            isPurchaseOrderSuccess
              ? "messageBox.buttons.close"
              : purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoice
                ? "jobBoard.purchaseOrderPopup.submitInvoice"
                : isPayStep
                  ? "jobBoard.purchaseOrderPopup.payButton"
                  : "jobBoard.purchaseOrderPopup.generatePO"
          }/>}
        </button>
      )}
    </div>
  )
};

JobPurchaseOrderPopupFooterButtons.propTypes = {
  closePopup: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {purchaseOrderStep, purchaseOrderInvoiceFile, purchaseOrderInvoiceNumber} = store.jobPurchaseOrderPopupState;
  const {jobCartItems, jobEditPopupIframeWaitingReceipt} = store.jobEditPopupState;

  return {
    purchaseOrderStep,
    purchaseOrderInvoiceFile,
    purchaseOrderInvoiceNumber,
    jobCartItems,
    jobEditPopupIframeWaitingReceipt,
  };
};

const mapDispatchToProps = {
  setJobPurchaseOrderPopupStep,
  updateJobOrder,
  setJobPurchaseOrderErrorMessage,
  setJobEditPopupIframeWaitingReceipt,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPurchaseOrderPopupFooterButtons)
)
